import { Outlet, useNavigate, useOutletContext } from "react-router";
import { useRootLoader } from "@/hooks/useRootLoader";
import { checkRoleIsSysadmin } from "@/utils/role";
import { ROUTE_403 } from "@/utils/const";
import { useEffect } from "react";

/**
 * sysadmin限定ルートのガードコンポーネント
 * admin + specialFlags["sysadmin"] が必要
 */
export function SysadminGuard() {
  const { auth } = useRootLoader();
  const navigate = useNavigate();
  const context = useOutletContext();
  const isSysadmin = checkRoleIsSysadmin(auth);

  useEffect(() => {
    if (!isSysadmin) {
      navigate(ROUTE_403, { replace: true });
    }
  }, [isSysadmin, navigate]);

  if (!isSysadmin) {
    return null;
  }

  return <Outlet context={context} />;
}
